import ScheduleEntry from '../models/ScheduleEntry';
import type { ConflictReason } from '../services/AvailabilityService';

export function getScheduleEntryPeriodId(
  entry: {
    periodId?: string | number | null;
    period_id?: string | number | null;
    additionalProps?: { periodId?: string | number | null; period_id?: string | number | null };
  } | null | undefined
): string | number | null {
  if (!entry) return null;
  return entry.periodId
    ?? entry.period_id
    ?? entry.additionalProps?.periodId
    ?? entry.additionalProps?.period_id
    ?? null;
}

export function mergeConflictPeerEntries(
  draftEntries: ScheduleEntry[],
  overlappingPeerEntries: ScheduleEntry[]
): ScheduleEntry[] {
  const merged = [...draftEntries];
  const seenIds = new Set(
    draftEntries.map((entry) => entry?.id).filter((id): id is string => Boolean(id))
  );

  overlappingPeerEntries.forEach((entry) => {
    if (!entry?.id || seenIds.has(entry.id)) {
      return;
    }
    seenIds.add(entry.id);
    merged.push(entry);
  });

  return merged;
}

export type DisplayConflictReason = ConflictReason & {
  isCrossPeriod?: boolean;
  otherPeriodName?: string;
};

export function decorateConflictReasonForDisplay(
  reason: ConflictReason,
  getPeriodName: (periodId: string | number) => string
): DisplayConflictReason {
  if (!reason.isCrossPeriod || reason.conflictingPeriodId == null) {
    return { ...reason, isCrossPeriod: false };
  }

  return {
    ...reason,
    isCrossPeriod: true,
    otherPeriodName: getPeriodName(reason.conflictingPeriodId),
  };
}
